import { useState } from "react";
import { useAuthStore } from "../stores/useAuthStore";

const useLogin = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const { setTokens } = useAuthStore();

    const login = async (username, password) => {
        setLoading(true);
        setError("");
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_AUTH}/auth/token`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        client_id: process.env.REACT_APP_CLIENT_ID,
                        grant_type: "password",
                        username,
                        password,
                    }),
                }
            );

            const data = await response.json();

            if (response.ok) {
                const { access_token, refresh_token, user } = data;
                setTokens(access_token, refresh_token, user);
                return { success: true, data };
            } else {
                const errorMessage = data.message || "Credenciales incorrectas";
                setError(errorMessage);
                return { success: false, error: errorMessage };
            }
        } catch (error) {
            console.error("Error durante el login:", error);
            const errorMessage =
                "Error de conexión. Por favor, intenta nuevamente.";
            setError(errorMessage);
            return { success: false, error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    const clearError = () => setError("");

    return {
        login,
        loading,
        error,
        clearError,
    };
};

export default useLogin;
